export * from './inflationhedge-potential-return'
